module.exports = __webpack_public_path__ + "assets/img/4575d2a975c93b4b7b2c0f73f83c9fa1.png";